import React from 'react';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';
import Card from '../ui/Card';

export const CapabilitiesSection: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const pillars = [
    {
      icon: 'architecture',
      title: 'Building Envelope & Façade',
      items: ['Curtain Walls', 'ACP Cladding', 'HPL & Zinc Sheets', 'Thermal Insulation'],
    },
    {
      icon: 'layers',
      title: 'Glass & Architectural Systems',
      items: ['Structural Glazing', 'Canopies & Skylights', 'Patch Fittings', 'Glass Partitions'],
    },
    {
      icon: 'construction',
      title: 'Civil & Construction',
      items: ['MS Fabrication', 'Commercial Civil Works', 'Retrofitting', 'Structural Reinforcement'],
    },
    {
      icon: 'security',
      title: 'Infrastructure & Safety',
      items: ['Parking Management', 'Road Safety Systems', 'Automated Barriers', 'Signage Solutions'],
    },
  ];

  return (
    <Box
      id="capabilities"
      sx={{
        py: { xs: 10, md: 14 },
        backgroundColor: isDark ? '#0b0f19' : '#ffffff',
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'flex-end' }, mb: 8, gap: 3 }}>
          <Box sx={{ maxWidth: 700 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2rem', md: '2.75rem' },
                color: theme.palette.text.primary,
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                mb: 1.5,
              }}
            >
              Specialised Disciplines
            </Typography>
            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.05rem' }}>
              Precision engineering meets high-end architectural vision. We bridge the gap between design complexity and structural reliability.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: theme.palette.primary.main, fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer' }}>
            CAPABILITIES
            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>arrow_right_alt</span>
          </Box>
        </Box>

        <Grid container spacing={3}>
          {pillars.map((pillar, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card
                glowOnHover
                sx={{
                  height: '100%',
                  p: 4,
                  backgroundColor: isDark ? '#161d2f' : '#f8fafc',
                  borderColor: theme.palette.divider,
                  boxShadow: isDark ? 'none' : '0 4px 16px rgba(0, 0, 0, 0.03)',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s ease',
                }}
              >
                <Box sx={{ mb: 3 }}>
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: 40, color: theme.palette.primary.main }}
                  >
                    {pillar.icon}
                  </span>
                </Box>

                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.primary, fontWeight: 600, fontFamily: 'Space Grotesk', mb: 3 }}
                >
                  {pillar.title}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2, mt: 'auto' }}>
                  {pillar.items.map((item, idx) => (
                    <Typography key={idx} variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
                      • {item}
                    </Typography>
                  ))}
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CapabilitiesSection;
